import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../LanguageContext';
import useSignOut from '../hooks/useSignOut';

function SignOut() {
  const { language } = useContext(LanguageContext);
  const signOut = useSignOut();

  useEffect(() => {
    // Clear the temporary store
    localStorage.removeItem('appointmentData');

    const doLogout = async () => {
      await signOut({ redirectTo: null, hostedLogout: false });
    };
    doLogout();
  }, [signOut]);

  return (
    <div>
      <main className="govuk-main-wrapper govuk-width-container" role="main">
        <h1 className="govuk-heading">
          {language === 'en' ? 'You have been signed out' : 'Vous avez été déconnecté'}
        </h1>
        <p className="govuk-body">
          {language === 'en'
            ? 'For privacy, the portal has ended your session. Sign in again when you are ready.'
            : 'Pour protéger votre confidentialité, le portail a mis fin à votre session. Reconnectez-vous lorsque le moment vous convient.'}
        </p>
        <Link to="/login" className="govuk-link">
          {language === 'en' ? 'Sign in again' : 'Se reconnecter'}
        </Link>
      </main>
    </div>
  );
}

export default SignOut;
